export default __webpack_public_path__ + "static/media/bgAsideDt.2f1b1ba6.png";